/**
 * Returns the object if all values are truthy, otherwise returns the default.
 */
export function allOr<T extends Record<string, unknown>>(obj: T): T | null;
export function allOr<T extends Record<string, unknown>, D>(
  obj: T,
  defaultValue: D
): T | D;
export function allOr<T extends Record<string, unknown>, D = null>(
  obj: T,
  defaultValue?: D
): T | D | null {
  return Object.values(obj).every(Boolean) ? obj : (defaultValue ?? null);
}
